// @flow
import React, { Component, lazy, Suspense } from "react";
import ReactDOM from "react-dom";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import RootRef from "@material-ui/core/RootRef";
import Chip from "@material-ui/core/Chip";

import AuthorisedLabel from "../companies/AuthorisedLabel";
import LicenceTypeLabel from "../licences/LicenceTypeLable";
import {
  isMomentBefore,
  isMomentAfter
} from "../../../global/functions/DateTimeAmend";
import { LoadingProgress, NoItem } from "imagus-components";

const QuoteItem = lazy(
  (): * => import("../../containers/quotes/QuoteItemRedux")
);

type QuoteListStatesType = {
  expanded: null | string
};

type QuoteListPropsType = {
  quotes: Array<*>,
  currentCompany?: { [key: string]: * },
  isAdmin?: boolean,
  canEdit?: boolean,
  openSnackbar?: Function,
  setActionError?: Function,
  preLoadId?: string,
  companyFilter?: Array<*>,
  dateStartFilter?: Date | null,
  dateEndFilter?: Date | null,
  licenceFilter?: string,
  resellerFilter?: string,
  tierFilter?: string,
  priceFilter?: string
};

class QuoteList extends Component<QuoteListPropsType, QuoteListStatesType> {
  constructor(props: QuoteListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
    this.panelRefs = {};
  }

  setRef = (id: string): * => (ref: *): * => {
    this.panelRefs[id] = ref;
  };

  componentDidMount() {
    if (this.props.preLoadId) {
      this.setState(
        { expanded: this.props.preLoadId },
        (): * => {
          let ref = this.panelRefs[this.props.preLoadId];
          if (ref) {
            ref.scrollIntoView();
          }
        }
      );
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const quotes = this.props.quotes;
    const list =
      quotes &&
      quotes.map(
        (quote: *, i: number): * => {
          let display = true;
          if (this.props.companyFilter && this.props.companyFilter.length > 0) {
            if (this.props.companyFilter.indexOf(quote.createdCompanyId) < 0) {
              display = false;
            }
          }
          if (this.props.dateStartFilter) {
            if (
              isMomentBefore(quote.createDateOrigin, this.props.dateStartFilter)
            ) {
              display = false;
            }
          }
          if (this.props.dateEndFilter) {
            if (
              isMomentAfter(quote.createDateOrigin, this.props.dateEndFilter)
            ) {
              display = false;
            }
          }
          if (this.props.licenceFilter && this.props.licenceFilter !== "ALL") {
            if (quote.licenceType !== this.props.licenceFilter) {
              display = false;
            }
          }
          if (
            this.props.resellerFilter &&
            this.props.resellerFilter !== "ALL"
          ) {
            if (quote.authorised !== parseInt(this.props.resellerFilter)) {
              display = false;
            }
          }
          if (this.props.tierFilter && this.props.tierFilter !== "ALL") {
            if (quote.tierId !== this.props.tierFilter) {
              display = false;
            }
          }
          if (this.props.priceFilter && this.props.priceFilter !== "ALL") {
            if (this.props.priceFilter === "BASE") {
              if (quote.productSheetId !== null) {
                display = false;
              }
            } else {
              if (quote.productSheetId !== this.props.priceFilter) {
                display = false;
              }
            }
          }
          if (display) {
            let createdByToggle =
              (this.props.currentCompany &&
                quote.createdCompanyUid !== this.props.currentCompany.uuid) ||
              this.props.isAdmin;
            return (
              <RootRef rootRef={this.setRef(quote.id)} key={quote.id}>
                <ExpansionPanel
                  expanded={expanded === quote.id}
                  onChange={this.handleChange(quote.id)}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" className="heading">
                      <b>Company Name</b> {quote.company_name}
                    </Typography>
                    <Typography variant="subtitle1" className="subheading">
                      <b>Created On</b> {quote.createDate}
                      {createdByToggle && (
                        <span>
                          {" "}
                          <b>By</b> {quote.createdCompanyName}
                        </span>
                      )}
                      {quote.updateDate !== "" && (
                        <span>
                          {" "}
                          <b>Edited On</b> {quote.updateDate}
                        </span>
                      )}
                    </Typography>
                    <span className="subtitle1">
                      <AuthorisedLabel status={quote.authorised} />
                      {quote.licence ? (
                        <Chip
                          label="Upgrade Licence"
                          className="blue-label left-margin-20"
                          style={{ display: "inline-flex" }}
                        />
                      ) : (
                        <LicenceTypeLabel
                          licenceType={quote.licenceType}
                          className="left-margin-20"
                        />
                      )}
                    </span>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Suspense fallback={<LoadingProgress />}>
                      {expanded === quote.id && (
                        <QuoteItem
                          quote={quote}
                          isAdmin={this.props.isAdmin}
                          openSnackbar={this.props.openSnackbar}
                          setActionError={this.props.setActionError}
                          canEdit={this.props.canEdit}
                        />
                      )}
                    </Suspense>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </RootRef>
            );
          } else {
            return null;
          }
        }
      );
    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {(list.filter(item => item !== null).length === 0 && (
              <NoItem content="No Quote has found." />
            )) ||
              list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default QuoteList;
